import React from 'react';
import Skeleton from '@mui/material/Skeleton';

export function LevelV2Skeleton() {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        padding: '1rem',
        alignItems: 'center',
      }}
      className="qlf-skeleton"
    >
      <Skeleton variant="circular" width="12rem" height="12rem" style={{ marginTop: '2rem' }} />
      <Skeleton variant="text" width="8rem" height="2rem" style={{ marginTop: '1rem' }} />
      <Skeleton variant="text" width="10rem" height="1.5rem" />
      <Skeleton variant="text" width="8rem" height="1.5rem" />
    </div>
  );
}
